module.exports = __webpack_public_path__ + "media/images/unite4-e5910443e36bae6982c06016d79246fc.png";